export const normalizeReservationImageUrl = (imageUrl) => {
  if (!imageUrl) return '';

  if (
    imageUrl.startsWith('http') ||
    imageUrl.startsWith('data:') ||
    imageUrl.startsWith('blob:')
  ) {
    return imageUrl;
  }

  const currentDomain = typeof window !== 'undefined' ? window.location.origin : '';
  const normalizedPath = imageUrl.replace(/\\/g, '/');

  const uploadsMarker = '/uploads/';
  const uploadsIndex = normalizedPath.indexOf(uploadsMarker);
  if (uploadsIndex >= 0) {
    const relativePath = normalizedPath.slice(uploadsIndex + uploadsMarker.length);
    return `${currentDomain}/uploads/${relativePath}`;
  }

  if (normalizedPath.startsWith('uploads/')) {
    return `${currentDomain}/${normalizedPath}`;
  }

  return `${currentDomain}${normalizedPath.startsWith('/') ? '' : '/'}${normalizedPath}`;
};

export const getReservationImageEntryUrl = (entry) => {
  if (!entry) return null;
  if (typeof entry === 'string') return entry;
  return entry.image_url || entry.url || entry.preview || null;
};

const getLegacyImageUrl = (legacyImage) => {
  if (!legacyImage) return null;
  if (Array.isArray(legacyImage)) return legacyImage[0] || null;
  if (typeof legacyImage === 'string' && legacyImage.includes(',')) {
    return legacyImage.split(',')[0].trim();
  }
  return legacyImage;
};

export const getReservationPrimaryImageUrl = (reservation) => {
  const imageFromArray = reservation?.images
    ?.map(getReservationImageEntryUrl)
    .find(Boolean);

  const rawImageUrl = imageFromArray || getLegacyImageUrl(reservation?.design_image);
  return normalizeReservationImageUrl(rawImageUrl);
};
